import {
  TextField,
  InputLabel,
  Slider,
  Typography,
  Card,
  Container,
  Tooltip,
  TableHead,
  TableCell,
  TableRow,
  Button,
  List,
  ListItem,
  Badge,
  Modal,
  DialogContent,
  Alert,
  ToggleButtonGroup, 
  ToggleButton
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { withStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
export const StyleContainer = withStyles({
  maxWidthXl: {
    maxWidth: 1366,
  },
})(Container);

export const pmTheme = createTheme({
  palette: {
    primary: {
      light: "#213F52",
      main: "#1c3545",
      dark: "#3C7091",
      contrastText: "#fff",
    },
    secondary: {
      light: "#E87A07",
      main: "#ff6a15",
      dark: "#E83907",
      contrastText: "#fff",
    },
    error: {
      light: "#FF1535",
      main: "#FF1535",
      dark: "#FF1535",
      contrastText: "#fff",
    },
    success: {
      light: "#00C848",
      main: "#00C848",
      dark: "#00C848",
      contrastText: "#fff",
    },
  },
});

export const NoBorderTextField = withStyles({
  root: {
    height: 20,
    "& div:focus": {
      borderRadius: 3,
      backgroundColor: "transparent",
    },
    "& input:valid + svg + fieldset": {
      borderWidth: "0!important",
    },
    "& input:disabled + svg + fieldset": {
      borderWidth: "0!important",
    },
    "& input:invalid + svg + fieldset": {
      borderWidth: 0,
    },
    "& input:valid:focus + svg + fieldset": {
      borderWidth: 0,
    },
    "& input + svg": {
      color: "#1c3545",
    },
  },
})(TextField);

export const StyledToggleButtonGroup = withStyles({
  grouped: {
    border: "none",
    color: "#1c3545",
    padding: "5px 10px",
    textTransform: "none",
    borderRadius: 4,
    "&:not(:first-child)": {
      borderRadius: 4,
    },
    "&:first-child": {
      borderRadius: 4,
    },
  },
})(ToggleButtonGroup);
export const StyledToggleButton = withStyles({
  selected: {
    backgroundColor: "#ff6a15!important",
    color: "#ffffff!important",
  },
})(ToggleButton);

export const mapContainerStyle = {
  width: "100%",
  height: "470px",
};
export const AboutLocationMapContainer = {
  width: "100%",
  height: "400px",
};

export const StyleInputLabel = withStyles({
  root: {
    fontSize: 18,
    fontWeight: 500,
    color: "#1c3545",
    marginBottom: 25,
    maxHeight: 18
  },
})(InputLabel);

export const BoxIconWithTextGroup = withStyles({
  grouped: {
    backgroundColor: "#ffffff!important",
    color: "#1c3545!important",
    borderWidth: 1,
    borderColor: "#1c3545!important",
    width: 130,
    height: 130,
    padding: "5px 10px",
    textTransform: "none",
    borderRadius: 4,
    marginRight: 20,
    display: "block",
    opacity:0.6,
    "&:not(:first-child)": {
      borderRadius: 4,
    },
    "&:first-child": {
      borderRadius: 4,
    },
  },
})(ToggleButtonGroup);

export const BoxIconWithText = withStyles({
  selected: {
    borderColor: "#ff6a15!important",
    color: "#ff6a15!important",
    "& svg path": {
      fill: "#ff6a15!important",
    },
    opacity:1,
  },
})(ToggleButton);

export const StyleTextField = withStyles({
  root: {
    borderColor: "#1c3545!important",
    color: "#1c3545!important",
    height: 50,
    width: "100%",
    "& input": {
      color: "#1c3545!important",
      borderColor: "#1c3545!important",
    },
    "& fieldset": {
      color: "#1c3545!important",
      borderColor: "#1c3545!important",
    },
    "& .Mui-disabled":{
      backgroundColor:"#ececec!important",
      cursor: "no-drop",
    },
    "& .MuiGrid-item":{
      padding:"8px !important",
    }
  },
 
})(TextField);

export const StyleSlider = withStyles({
  root: {
    borderColor: "#1c3545!important",
    color: "#1c3545!important",
    marginTop: 15,
  },
  rail: {
    height: 3,
  },
  track: {
    height: 3,
    backgroundColor: "#1c3545",
  },
  thumb: {
    height: 17,
    width: 17,
    backgroundColor: "#1c3545",
    borderColor: "#ffffff",
    borderWidth: 1,
    borderStyle: "solid",
    marginTop: -7,
  },
})(Slider);

export const IconWithTextGroup = withStyles({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  grouped: {
    backgroundColor: "Transparent!important",
    color: "#1c3545!important",
    borderWidth: 0,
    width: "18%",
    height: 50,
    textTransform: "none",
    borderRadius: 0,
    marginRight: "2%",
    textAlign: "left",
    display: "flex",
    justifyContent: "left",
    "&:not(:first-child)": {
      borderRadius: 0,
    },
    "&:first-child": {
      borderRadius: 0,
    },
  },
})(ToggleButtonGroup);

export const IconWithText = withStyles({
  root: {
    "& span .icon--wrapper svg path": {
      fill: "#1c3545!important",
    },
  },
  selected: {
    "& span .icon--wrapper": {
      backgroundColor: "#ff6a15!important",
    },
    "& span .icon--wrapper svg path": {
      fill: "#ffffff!important",
    },
    "& span p": {
      color: "#1c3545!important",
    },
  },
  label: {
    color: "rgba(28, 53, 69, 0.6)",
  },
})(ToggleButton);

export const StyleHeading = withStyles({
  h1: {
    fontSize: 36,
    "@media (max-width: 1200px)": {
      fontSize: 26,
    },
    "@media (max-width: 700px)": {
      fontSize: 20,
    },
  },
  h2: {
    fontSize: 32,
    "@media (max-width: 1200px)": {
      fontSize: 22,
    },
  },
  h3: {
    fontSize: 28,
    "@media (max-width: 1200px)": {
      fontSize: 20,
    },
  },
  h4: {
    fontSize: 20,
    "@media (max-width: 1200px)": {
      fontSize: 16,
    },
  },
  h5: {
    fontSize: 16,
    "@media (max-width: 1200px)": {
      fontSize: 12,
    },
  },
  h6: {
    fontSize: 12,
    "@media (max-width: 1200px)": {
      fontSize: 10,
    },
  },
})(Typography);

export const StyleCard = withStyles({
  root: {
    borderRadius: 0,
    borderColor: "#555555",
    height: 320,
    
    "@media (max-width: 1024px)": {
      height: 280,
    },
    "@media (max-width: 700px)": {
      height: 300,
    },
    "& p":{
      fontSize: '1rem',
    },
    "& p strong":{
      fontSize: '1rem',
    }
  },
})(Card);

export const StyleInfoTypography = withStyles({
  root: {
    color: "#4D6E99",
    "@media (max-width: 1200px)": {
      fontSize: "0.9rem",
    },
  },
})(Typography);

export const StyleSuccessTypography = withStyles({
  root: {
    color: "#00C848",
  },
})(Typography);

export const StyleTypography = withStyles({
  root: {
    fontSize: "1.1rem",
    "@media (max-width: 1200px)": {
      fontSize: "0.85rem",
    },
  },
})(Typography);

export const StyleTooltip = withStyles({
  tooltip: {
    backgroundColor: "#1c3545",
    fontSize: "0.9rem",
  },
  arrow: {
    color: "#1c3545",
  },
})(Tooltip);

export const StyleTableHead = withStyles({
  root: {
    backgroundColor: "#1c3545",
  },
})(TableHead);

export const StyleTableRow = withStyles({
  root: {
    "&:nth-child(even)": {
      backgroundColor: "#E7EBED",
    },
  },
})(TableRow);
export const StyleTableCell = withStyles({
  root: {
    fontSize:'1rem',
  },
})(TableCell);

export const StyleTableHeadCell = withStyles({
  root: {
    color: "#ffffff",
    fontWeight: 500,
    fontSize:'1rem',
   
    "@media (max-width: 700px)": {
      whiteSpace: "nowrap",
    },
  },
})(TableCell);

export const StyleAlert = withStyles({
  root: {
    width: "auto",
  },
  filledSuccess: {
    backgroundColor: "#28DA68",
  },
  filledWarning: {
    backgroundColor: "#FF7803",
  },
  filledError: {
    backgroundColor: "#FF425C",
  },
  filledInfo: {
    backgroundColor: "#748CAC",
  },
  message: {
    fontWeight: 300,
    fontSize: 18,
    paddingTop: 5,
    "@media (max-width: 700px)": {
      fontSize: 14,
    },
  },
})(Alert);

export const StyleButton = withStyles({
  root: {
    textTransform: "none",
    boxShadow: "none",
    fontSize: 16
  },
})(Button);

export const StyleButtonLarge = withStyles({
  root: {
    textTransform: "none",
    height: 50,
    boxShadow: "none",
    fontSize: 16,
    "@media (max-width: 1200px)": {
      fontSize: 13,
      padding: "8px 12px",
    },
    "@media (max-width: 840px)": {
      width:'100%'
    },
  },
})(Button);
export const StickyButton = withStyles({
  root: {
    textTransform: "none",
    height: 50,
    boxShadow: "none",
    fontSize: 16,
    "@media (max-width: 1200px)": {
      fontSize: 13,
      padding: "8px 12px",
    },
  },
})(Button);
export const StyleInfoButtonLarge = withStyles({
  root: {
    textTransform: "none",
    height: 50,
    boxShadow: "none",
    fontSize: 16,
    backgroundColor:"#4D6E99",
    "@media (max-width: 1200px)": {
      fontSize: 13,
      padding: "8px 12px",
    },
  },
})(Button);

export const StyleTooltipMessage = withStyles({
  tooltip: {
    backgroundColor: "#1c3545",
    fontSize: "0.8rem",
    padding: 20,
  },
  arrow: {
    color: "#1c3545",
  },
})(Tooltip);

export const StyleTooltipMessage2 = withStyles({
  tooltip: {
    backgroundColor: "#1c3545",
    fontSize: "0.8rem",
    padding: 20,
    maxWidth:500,
    whiteSpace:'pre-line'
  },
  arrow: {
    color: "#1c3545",
  },
})(Tooltip);

export const StyleOrderList = withStyles({
  root: {
    listStyle: 'decimal',
    listStyleType: 'decimal'
  },

})(List);

export const StyleOrderListItem = withStyles({
  root: {
    display:'list-item',
    fontSize:'0.9rem',
    marginLeft:15,
    color: "#1c3545",
    fontWeight:400
  },

})(ListItem);

export const StyledBadge = withStyles({
  badge: {
    right: -29,
    bottom:10,
    padding: 10,
  },
})(Badge);

export const IconButtonGroup = withStyles({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  grouped: {
    backgroundColor: "Transparent!important",
    color: "#1c3545!important",
    borderWidth: 0,
    width: 210,
    height: 210,
    textTransform: "none",
    borderRadius: 0,
    textAlign: "left",
    display: "flex",
    justifyContent: "left",
    "&:not(:first-child)": {
      borderRadius: 0,
    },
    "&:first-child": {
      borderRadius: 0,
    },
  },
})(ToggleButtonGroup);



export const IconButton = withStyles({
  selected: {
    color: "#ff6a15!important",
    "& svg path": {
      fill: "#ff6a15!important",
    },
    "& svg rect": {
      fill: "#ff6a15!important",
    },
    opacity:1,
  },
})(ToggleButton);

export const StyleToggleButton = withStyles({
  root:{
    textTransform:'none',
    marginRight:20,
    borderRadius:'4px!important',
    backgroundColor:"rgba(28, 53, 69, 0.2)",
    color:'#1c3545!important',
    '&:hover':{
      backgroundColor: "#ff6a15!important",
      color:"#ffffff!important",
    }
  },
  selected: {
    backgroundColor: "#ff6a15!important",
    color:"#ffffff!important",
    borderRadius:'4px!important',

  },
})(ToggleButton);

export const StyleModal = withStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))(Modal);

export const StyleWhiteCircularProgress = withStyles((theme) => ({
  root:{
    marginLeft:10,
  },
  colorPrimary: {
   color:"#ffffff"
  },
}))(CircularProgress);

export const StyleDialogContent = withStyles((theme) => ({
  root:{
    padding:20
  },
  
}))(DialogContent);
